export const SUBSCRIPTION_PANEL_CONFIG = {
  title: 'Subscription earnings - detail',
  subtitleLabel: 'subscription downloads',
  emptyMessage: 'No subscription downloads in this period.',
  monthlyEarningsTooltip: 'Earnings from subscription downloads this period.',
  totalEarnedTooltip: 'Cumulative subscription earnings since opt-in.',
}

export const EARNINGS_DETAIL_TYPES = {
  sales: 'sales',
  downloads: 'downloads',
  subscriptionEarnings: 'subscription_earnings',
}

export const PER_PAGE_OPTIONS = [10, 40, 80]

export const REGULAR_EARNINGS_PANEL_CONFIG = {
  title: 'Regular earnings - detail',
  tabs: {
    sales: { id: EARNINGS_DETAIL_TYPES.sales, title: 'Sales' },
    downloads: { id: EARNINGS_DETAIL_TYPES.downloads, title: 'Downloads' },
  },
  emptyState: {
    sales: {
      title: "You haven't made a sale yet",
      description: 'Once your published models start selling, the details will appear here.',
    },
    salesForMonth: {
      title: 'No sales this month',
      description: (monthLabel) => `No sales were recorded for ${monthLabel}. Try a different month.`,
    },
    downloads: {
      title: 'No downloads yet',
      description: 'Once buyers start downloading your published models, the details will appear here.',
    },
    downloadsForMonth: {
      title: 'No downloads this month',
      description: (monthLabel) => `No downloads were recorded for ${monthLabel}. Try a different month.`,
    },
  },
}
